import { createFileRoute, useNavigate, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/hooks/use-auth";
import { AppShell } from "@/components/layout/AppShell";
import { Home, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/app")({
  component: AppLayout,
  notFoundComponent: AppNotFound,
});

function AppLayout() {
  const { loading, userId } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && !userId) nav({ to: "/login" });
  }, [loading, userId, nav]);

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center bg-background">
        <div className="text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }
  if (!userId) return null;
  return <AppShell />;
}

function AppNotFound() {
  const { profile } = useAuth();
  const isStaff = profile?.role === "staff" || profile?.role === "admin";

  return (
    <AppShell>
      <div className="flex flex-col items-center justify-center py-20">
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-2xl font-semibold text-foreground">Page not found</h2>
        <p className="mt-4 text-muted-foreground max-w-md text-center">
          The page you're looking for doesn't exist or has been moved within the app.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/">
            <Button variant="default" className="rounded-full">
              <Home className="mr-2 h-4 w-4" /> Home
            </Button>
          </Link>
          <Link to="/help">
            <Button variant="outline" className="rounded-full">
              <HelpCircle className="mr-2 h-4 w-4" /> Help Center
            </Button>
          </Link>
          <Link to={isStaff ? "/app/staff/jobs-board" : "/app/customer/dashboard"}>
            <Button variant="outline" className="rounded-full">
              Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </AppShell>
  );
}
